import React from 'react';
import PropTypes from 'prop-types';

const Image = props => {
  const { src, height } = props;
  return (
    <img
      src={src}
      alt="menu-item"
      height={height}
      style={{
        position: 'relative',
        objectFit: 'cover',
        height: '100%',
        width: '100%'
      }}
      data-testid="image-id"
    />
  );
};

export default Image;

Image.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.string
};
